<app-breadcrumb [master]="'Rozliczenia'" [parentName]="'Przepięcia polis'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group>
  <mat-tab label="Dane">
    <app-redirection-details-view
      *ngIf="!modify" [commissionRedirection]="commissionRedirection"
      (modifyClicked)="modify = true" (changed)="loadCommissionRedirection()"
    ></app-redirection-details-view>
    <app-redirection-add
      *ngIf="modify" [commissionRedirection]="commissionRedirection"
      (closeModification)="modify = false; loadCommissionRedirection()"
    ></app-redirection-add>
  </mat-tab>
  <mat-tab label="Prowizje" [disabled]="!(userPermissions | async).settlement.read">
    <ng-template matTabContent>
      <app-all-commissions-list
        [embeddedView]="true" [commissionRedirection]="commissionRedirectionObject.uuid"
      ></app-all-commissions-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [commissionRedirection]="commissionRedirection"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
